'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleProgress = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _ProgressBase2 = require('../ProgressBase/ProgressBase');

var _ProgressBoxStyled = require('../styles/ProgressBoxStyled');

var _SecondaryLineStyled = require('./styles/SecondaryLineStyled');

var _ContentWrapperStyled = require('./styles/ContentWrapperStyled');

var _CircleWrapperStyled = require('./styles/CircleWrapperStyled');

var _CircleBoxStyled = require('./styles/CircleBoxStyled');

var _BgLineStyled = require('./styles/BgLineStyled');

var _PrimaryLineStyled = require('./styles/PrimaryLineStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = _extends({}, _ProgressBase2.ProgressBase.propTypes, {
  /**
   * Set circle diameter
   */
  circleSize: _propTypes2.default.number,
  /**
   * Set progress line thickness
   */
  strokeSize: _propTypes2.default.number
});

var defaultProps = _extends({}, _ProgressBase2.ProgressBase.defaultProps, {
  circleSize: 0,
  strokeSize: 0
});

var _CircleProgress = function (_ProgressBase) {
  _inherits(_CircleProgress, _ProgressBase);

  function _CircleProgress() {
    _classCallCheck(this, _CircleProgress);

    return _possibleConstructorReturn(this, (_CircleProgress.__proto__ || Object.getPrototypeOf(_CircleProgress)).apply(this, arguments));
  }

  _createClass(_CircleProgress, [{
    key: '_renderSecondaryProgressCircle',
    value: function _renderSecondaryProgressCircle() {
      var _props = this.props,
          indeterminate = _props.indeterminate,
          withSecondaryProgress = _props.withSecondaryProgress;


      if (indeterminate || !withSecondaryProgress) return null;

      var normalizedSecondaryProgress = this._getNormalizedSecondaryProgress();
      var circleLength = this.circleLength;
      var circleRadius = this.circleRadius;
      var circleCenter = this.circleCenter;
      var secondaryProgressLength = normalizedSecondaryProgress * circleLength;

      var progressSecondaryStyle = {
        stroke: this._getSecondaryProgressColor('circle').string(),
        strokeDasharray: secondaryProgressLength + ' ' + circleLength
      };

      return _react2.default.createElement(_SecondaryLineStyled.SecondaryLineStyled, {
        r: circleRadius,
        cx: circleCenter,
        cy: circleCenter,
        customThickness: this.strokeSize,
        style: progressSecondaryStyle
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var indeterminate = this.props.indeterminate;


      var normalizedProgress = this._getNormalizedProgress();
      var viewBox = '0 0 ' + this.circleSize + ' ' + this.circleSize;
      var circleRadius = this.circleRadius;
      var circleCenter = this.circleCenter;
      var circleLength = this.circleLength;
      var progressLength = normalizedProgress * circleLength;
      var bgStyle = {
        strokeDasharray: circleLength + ' ' + circleLength
      };

      var progressAdditionalStyle = void 0;
      if (indeterminate) {
        progressAdditionalStyle = {
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        };
      } else {
        progressAdditionalStyle = {
          strokeDasharray: progressLength + ' ' + circleLength
        };
      }

      var progressPrimaryStyle = _extends({
        stroke: this._getProgressColor('circle').string()
      }, progressAdditionalStyle);

      var strokeSize = this.strokeSize;

      return _react2.default.createElement(
        _ProgressBoxStyled.ProgressBoxStyled,
        this._getAriaAttributes(),
        this._renderLabel('circle'),
        _react2.default.createElement(
          _ContentWrapperStyled.ContentWrapperStyled,
          { customDiameter: this.circleSize },
          _react2.default.createElement(
            _CircleWrapperStyled.CircleWrapperStyled,
            null,
            _react2.default.createElement(
              _CircleBoxStyled.CircleBoxStyled,
              {
                viewBox: viewBox,
                customDiameter: this.circleSize,
                shapeRendering: 'geometricPrecision',
                indeterminate: this.props.indeterminate
              },
              _react2.default.createElement(_BgLineStyled.BgLineStyled, {
                r: circleRadius,
                cx: circleCenter,
                cy: circleCenter,
                style: bgStyle,
                customThickness: strokeSize
              }),
              this._renderSecondaryProgressCircle(),
              _react2.default.createElement(_PrimaryLineStyled.PrimaryLineStyled, {
                r: circleRadius,
                cx: circleCenter,
                cy: circleCenter,
                customThickness: strokeSize,
                style: progressPrimaryStyle,
                circleLength: this.circleLength,
                indeterminate: this.props.indeterminate
              })
            )
          )
        )
      );
    }
  }, {
    key: 'theme',
    get: function get() {
      return this.props.theme.reactackle.components.progress.circle;
    }
  }, {
    key: 'circleSize',
    get: function get() {
      return this.props.circleSize || this.theme.circleSize;
    }
  }, {
    key: 'strokeSize',
    get: function get() {
      return this.props.strokeSize || this.theme.strokeSize;
    }
  }, {
    key: 'circleRadius',
    get: function get() {
      return this.circleSize / 2 - this.strokeSize / 2;
    }
  }, {
    key: 'circleLength',
    get: function get() {
      return 2 * this.circleRadius * Math.PI;
    }
  }, {
    key: 'circleCenter',
    get: function get() {
      return this.circleSize / 2;
    }
  }]);

  return _CircleProgress;
}(_ProgressBase2.ProgressBase);

_CircleProgress.propTypes = propTypes;
_CircleProgress.defaultProps = defaultProps;
_CircleProgress.displayName = 'CircleProgress';

var CircleProgress = exports.CircleProgress = (0, _reactackleCore.withTheme)(_CircleProgress);


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-progress/dist/CircleProgress/CircleProgress.js
// module id = 218
// module chunks = 0